/** Shared look of the inline add/import forms (Banks, Rates, BCA). */
export const FORM_CARD = 'rounded-lg border border-border bg-card p-4'

/** Solid filter bar. Glass is only for floating controls, and this sits in the content. */
export const FILTER_BAR = 'rounded-lg border border-border bg-card p-3'
